const localeFromPath = (pathname, sitewideLocales) => {
  return sitewideLocales.find(
    (locale) => pathname.startsWith(`/${locale.abbreviation}/`) || pathname === `/${locale.abbreviation}`
  );
};
const pathWithoutLocale = (pathname, sitewideLocales) => {
  const locale = localeFromPath(pathname, sitewideLocales);
  if (!locale) return pathname;
  return pathname.replace(`/${locale.abbreviation}`, "");
};
const pathHasLocalizedVariant = (pathname, locale, localizedPathCollection) => {
  return (localizedPathCollection == null ? void 0 : localizedPathCollection.some(
    (localizedPath) => localizedPath.unlocalizedPath.toLowerCase() === (pathname === "/" ? pathname : pathname.replace(/\/$/, "")).toLowerCase() && localizedPath.locales.some(
      (pathLocale) => pathLocale.abbreviation === locale.abbreviation
    )
  )) ?? false;
};
export {
  localeFromPath,
  pathHasLocalizedVariant,
  pathWithoutLocale
};
